<script lang="ts" setup>
const { isLoading, setIsLoading } = useStore();
const nuxtApp = useNuxtApp();
nuxtApp.hook("page:start", () => {
  setIsLoading(true)
});
nuxtApp.hook("page:finish", () => {
  setIsLoading(false);
});
</script>
<template>
    <div v-if="isLoading" class="spinner">
        <div class="lds-ripple">
            <div></div>
            <div></div>
        </div>
    </div>
</template>